var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.cadastrante.pessoa.pessoaFisica &&
      _vm.cadastrante.pessoa.pessoaFisica.cpf
        ? _c(
            "div",
            { key: "pessoaFisica" },
            [
              _c(
                "el-row",
                { staticClass: "labelDiv" },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaFisica.nome
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa.mudouNome
                                ? "text"
                                : "",
                            attrs: {
                              label: "Nome:",
                              content: _vm.cadastrante.pessoa.pessoaFisica.nome
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaFisica.cpf
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa.mudouCPF
                                ? "text"
                                : "",
                            attrs: {
                              label: "CPF:",
                              content: _vm.cadastrante.pessoa.pessoaFisica.cpf
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.cadastrante.pessoa.pessoaJuridica &&
      _vm.cadastrante.pessoa.pessoaJuridica.cnpj
        ? _c(
            "div",
            [
              _c(
                "el-row",
                { staticClass: "labelDiv" },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaJuridica.cnpj
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa.mudouCNPJ
                                ? "text"
                                : "",
                            attrs: {
                              label: "CNPJ:",
                              content:
                                _vm.cadastrante.pessoa.pessoaJuridica.cnpj
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaJuridica.razaoSocial
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouRazaoSocial
                                ? "text"
                                : "",
                            attrs: {
                              label: "Razão Social:",
                              content:
                                _vm.cadastrante.pessoa.pessoaJuridica
                                  .razaoSocial
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "app-divider",
                { attrs: { label: "Endereço" } },
                [
                  _c("informacoes-endereco", {
                    staticClass: "margin-top",
                    attrs: {
                      slot: "body",
                      endereco: _vm.enderecoCadastrante,
                      mudouEndereco:
                        _vm.compararCadastrante &&
                        _vm.compararCadastrante.mudouEndereco
                    },
                    slot: "body"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b0a1ff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0a1ff8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/InformacoesCadastrante.vue
// module id = null
// module chunks = 